import React from "react";
import clsx from "clsx";

import { ILesson, VideoChapter } from "../../../state";
import {
  prefixPath,
  projectionPath,
  videoLessonPath,
} from "../../../teacherStore";
import { ReactComponent as ProjectorIcon } from "../../../assets/svg/projector_2.svg";
import { ReactComponent as VideoProjectorIcon } from "../../../assets/svg/video_projector.svg";

import styles from "./GuidelineSidebar.module.scss";

export interface GuidelineSidebarProps {
  lesson: ILesson | null;
  videoChapters: VideoChapter[] | null;
  classListString: string;
  prevLessonId: number | null;
  nextLessonId: number | null;
  onChangeLesson: (lessonId: number) => void;
}

export const GuidelineSidebar: React.FC<GuidelineSidebarProps> = ({
  lesson,
  videoChapters,
  classListString,
  prevLessonId,
  nextLessonId,
  onChangeLesson,
}) => {
  const chapterId =
    videoChapters && videoChapters.length > 0 ? videoChapters[0].id : null;
  const hideVideoButton = !lesson?.name?.trim();
  const allVideosUnavailable =
    !videoChapters ||
    videoChapters.length === 0 ||
    videoChapters.every(chapter => !chapter.url);
  const hideMaterialButton = !lesson || lesson.teacher_only;

  const onShareMaterial = () =>
    lesson &&
    window.open(
      `${prefixPath}${projectionPath}?lesson=${lesson.id}&page=1&classList=${classListString}`,
      "_blank",
    );

  const onShareVideoMaterial = () =>
    lesson &&
    window.open(
      `${prefixPath}${videoLessonPath}?lesson=${lesson.id}&chapter=${chapterId}&classList=${classListString}`,
      "_blank",
    );

  const prevLesson = () => prevLessonId && onChangeLesson(prevLessonId);
  const nextLesson = () => nextLessonId && onChangeLesson(nextLessonId);

  return (
    <div className={styles.container}>
      <div className={styles.topSection}>
        <button
          className={clsx(
            styles.whiteSquareBtn,
            hideMaterialButton && styles.invisible,
          )}
          onClick={onShareMaterial}
        >
          <div className={styles.iconWrapper}>
            <ProjectorIcon className={styles.projectorIcon} />
          </div>
          <span className={styles.btnText}>スライドを投影</span>
        </button>
        <button
          className={clsx(
            styles.whiteSquareBtn,
            hideVideoButton && styles.invisible,
          )}
          onClick={onShareVideoMaterial}
          disabled={hideVideoButton || allVideosUnavailable}
        >
          <div className={styles.iconWrapper}>
            <VideoProjectorIcon className={styles.projectorIcon} />
          </div>
          <span className={styles.btnText}>ナビ動画を投影</span>
        </button>
      </div>
      <div className={styles.bottomSection}>
        <button
          onClick={prevLesson}
          disabled={!prevLessonId}
          className={styles.navBtn}
        >
          前の指導書
        </button>
        <button
          onClick={nextLesson}
          disabled={!nextLessonId}
          className={styles.navBtn}
        >
          次の指導書
        </button>
      </div>
    </div>
  );
};

export default GuidelineSidebar;
